import React, { Component } from 'react';
import './common/MdPage.css';
import { changePassword } from '../services/auth/usuarioService';
import { classifyApiError } from '../services/api/responseModel';

function PasswordToggleIcon({ visible }) {
  if (visible) {
    return (
      <svg className="md-page__password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    );
  }

  return (
    <svg className="md-page__password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a18.2 18.2 0 0 1-2.16 3.19" />
      <path d="M6.06 6.06A18.2 18.2 0 0 0 2 12s3.5 7 10 7a10.94 10.94 0 0 0 5.24-1.34" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <path d="M1 1l22 22" />
    </svg>
  );
}

export class CambiarContrasena extends Component {
  static displayName = CambiarContrasena.name;

  constructor(props) {
    super(props);
    this.state = {
      contraseniaActual: '',
      contraseniaNueva: '',
      contraseniaNuevaConfirmacion: '',
      showActual: false,
      showNueva: false,
      showConfirmacion: false,
      loading: false,
      errorMessage: '',
      successMessage: '',
    };
  }

  handleInputChange = (field) => (event) => {
    this.setState({ [field]: event.target.value, errorMessage: '', successMessage: '' });
  };

  toggleVisibility = (field) => () => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };

  isFormValid() {
    const { contraseniaActual, contraseniaNueva, contraseniaNuevaConfirmacion } = this.state;
    return (
      contraseniaActual.length > 0
      && contraseniaNueva.length > 0
      && contraseniaNuevaConfirmacion.length > 0
    );
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    if (this.state.loading) {
      return;
    }

    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Complete todos los campos.' });
      return;
    }

    if (this.state.contraseniaNueva !== this.state.contraseniaNuevaConfirmacion) {
      this.setState({ errorMessage: 'La nueva contraseña y su confirmación no coinciden.' });
      return;
    }

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    try {
      await changePassword({
        contraseniaActual: this.state.contraseniaActual,
        contraseniaNueva: this.state.contraseniaNueva,
        contraseniaNuevaConfirmacion: this.state.contraseniaNuevaConfirmacion,
      });

      this.setState({
        loading: false,
        contraseniaActual: '',
        contraseniaNueva: '',
        contraseniaNuevaConfirmacion: '',
        showActual: false,
        showNueva: false,
        showConfirmacion: false,
        successMessage: 'La contraseña se actualizó correctamente.',
      });
    } catch (error) {
      const classified = classifyApiError(error);
      this.setState({
        loading: false,
        errorMessage: classified.message || 'No se pudo cambiar la contraseña.',
      });
    }
  };

  renderPasswordField({
    id,
    label,
    value,
    onChange,
    show,
    onToggle,
    autoComplete,
    showAriaLabel,
    hideAriaLabel,
  }) {
    return (
      <div className="md-page__field">
        <label className="md-page__field-label" htmlFor={id}>
          {label}
        </label>
        <div className="md-page__password-wrap">
          <input
            id={id}
            className="md-page__field-input md-page__field-input--password"
            type={show ? 'text' : 'password'}
            autoComplete={autoComplete}
            disabled={this.state.loading}
            value={value}
            onChange={onChange}
          />
          <button
            type="button"
            className="md-page__password-toggle"
            onClick={onToggle}
            disabled={this.state.loading}
            title={show ? hideAriaLabel : showAriaLabel}
            aria-label={show ? hideAriaLabel : showAriaLabel}
            aria-pressed={show}
          >
            <PasswordToggleIcon visible={show} />
          </button>
        </div>
      </div>
    );
  }

  render() {
    const {
      loading,
      errorMessage,
      successMessage,
      contraseniaActual,
      contraseniaNueva,
      contraseniaNuevaConfirmacion,
      showActual,
      showNueva,
      showConfirmacion,
    } = this.state;

    return (
      <div className="md-page md-cambiar-contrasena">
        <div className="md-page__header">
          <h1 className="md-page__title">Cambiar contraseña</h1>
        </div>
        <p className="md-page__subtitle">
          Ingrese su contraseña actual y defina una nueva contraseña para su cuenta.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {errorMessage ? (
            <div className="md-page__error" role="alert">{errorMessage}</div>
          ) : null}
          {successMessage ? (
            <div className="md-page__success">{successMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Procesando cambio de contraseña...</div>
          ) : null}
        </div>

        <form className="md-page__form-card" onSubmit={this.handleSubmit} noValidate>
          {this.renderPasswordField({
            id: 'cp-actual',
            label: 'Contraseña actual',
            value: contraseniaActual,
            onChange: this.handleInputChange('contraseniaActual'),
            show: showActual,
            onToggle: this.toggleVisibility('showActual'),
            autoComplete: 'current-password',
            showAriaLabel: 'Mostrar contraseña actual',
            hideAriaLabel: 'Ocultar contraseña actual',
          })}

          {this.renderPasswordField({
            id: 'cp-nueva',
            label: 'Nueva contraseña',
            value: contraseniaNueva,
            onChange: this.handleInputChange('contraseniaNueva'),
            show: showNueva,
            onToggle: this.toggleVisibility('showNueva'),
            autoComplete: 'new-password',
            showAriaLabel: 'Mostrar nueva contraseña',
            hideAriaLabel: 'Ocultar nueva contraseña',
          })}

          {this.renderPasswordField({
            id: 'cp-confirmacion',
            label: 'Confirmar nueva contraseña',
            value: contraseniaNuevaConfirmacion,
            onChange: this.handleInputChange('contraseniaNuevaConfirmacion'),
            show: showConfirmacion,
            onToggle: this.toggleVisibility('showConfirmacion'),
            autoComplete: 'new-password',
            showAriaLabel: 'Mostrar confirmación',
            hideAriaLabel: 'Ocultar confirmación',
          })}

          <div className="md-page__form-actions">
            <button
              type="submit"
              className="md-page__form-btn md-page__form-btn--primary"
              disabled={loading}
            >
              Guardar contraseña
            </button>
          </div>
        </form>
      </div>
    );
  }
}
